module.exports = __webpack_public_path__ + "assets/img/icon_before.2465e79b.svg";